<template>
  <div id="app">
       <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import Utility from "@/components/common/functions.js";

export default {
  name: "app",
  data: () => ({
    // title: title,
    utility: Utility,
    drawer: false
  }),
  methods: {
    logout() {
      axios
        .post("/logout")
        .then(response => {
          this.$router.push("/");
          window.location.reload();
        })
        .catch(error => {
          location.reload();
        });
    },
    checkSession(){
        let self = this;
        let token = localStorage.getItem('token');
        let header = { headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                }
        }
        let avatar_url = process.env.VUE_APP_WASBI_URL

        // Public routes that should never redirect to login
        const publicRoutes = ['/', '/view-inventory', '/about-us', '/reviews'];
        const currentPath = self.$route ? self.$route.path : window.location.pathname;
        const isPublicPage = publicRoutes.includes(currentPath) ||
                             currentPath.startsWith('/view-inventory-details');

        axios.get('/api/user', header ).then(function (result) {
                if(result.data.status == 'Token is Invalid' || result.data.status == 'Token is Expired' || result.data.status == 'Authorization Token not found' || result.data.status == 'Token is Invalid - Password Changed' ){
                    console.log('session destroyed');
                    localStorage.removeItem("token")
                    localStorage.removeItem("user_id")
                    localStorage.removeItem("email")
                    localStorage.removeItem("role")
                    localStorage.removeItem("name")
                    localStorage.removeItem("is_admin")
                    // Only redirect to login if NOT on a public/inventory page
                    if (!isPublicPage) {
                      self.$router.push('/login')
                      self.$router.go();
                    }
                }else{
                  localStorage.setItem('credit',result.data.user.credit);
                  let preview = result.data.user.avatar ? avatar_url+result.data.user.avatar : ''
                  localStorage.setItem('avatar',preview);
                }
            }).catch(function (error) {
                console.log("session check failed:", error.message);
                // Only redirect to login if NOT on a public/inventory page
                if (!isPublicPage) {
                  self.$router.push('/login')
                }
        })
    },
    getDashoardCounts(){
        let header = { headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                }
        }
      axios.get('/api/getdashboard', header ).then(function (result) {
                console.log(result);
                localStorage.setItem('count_user', result.data.data.count_user)
                localStorage.setItem('count_total_booking', result.data.data.count_total_booking)
                localStorage.setItem('count_total_reserved', result.data.data.count_total_reserved)
                localStorage.setItem('count_parking', result.data.data.count_parking)
            }).catch(function (error) {
                console.log("session expired");
        })
    },
    getSettings() {
    let flag = 1;
    let url = process.env.VUE_APP_WASBI_URL
    var config = {headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
      axios({
          method: "POST",
          url: "/api/get-company-settings",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            let data = response.data.data;
            if(data){
               localStorage.setItem('settings', JSON.stringify(data.settings));
               if(data.settings.backgroung_logo)
                localStorage.setItem('admin_bg', JSON.stringify(url+data.settings.backgroung_logo));
              else
                localStorage.setItem('admin_bg','');
            }


         })
          .catch(err => {
            // Vue.$toast.error(err, {
            // position: 'top-right'
            // });

           });

     },
  getClientSettings() {
    let flag = 1;
    let url = process.env.VUE_APP_WASBI_URL
    var config = {headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
      axios({
          method: "GET",
          url: "/api/get-client-settings",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            let data = response.data.data;
            if(data){
              let settings = JSON.parse(data.settings)
               localStorage.setItem('welcome_video', settings.welcome_video);
               localStorage.setItem('welcome_vido_list_client', settings.list_client);
               localStorage.setItem('welcome_video_url', url+settings.welcome_video_url);
              //  localStorage.setItem('admin_bg', JSON.stringify(url+data.settings.backgroung_logo));
            }else{
              localStorage.setItem('welcome_video', 'None');
            }


         })
          .catch(err => {
            // Vue.$toast.error(err, {
            // position: 'top-right'
            // });

           });
          },
          getDomain() {
              let flag = 1;
              let url = process.env.VUE_APP_WASBI_URL
              var config = {headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
                axios({
                    method: "GET",
                    url: "/api/get-domain-settings",
                    headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
                  })
                  .then(response => {
                      let data = response.data.data;
                      if(data.flag == 1){
                        let settings = JSON.parse(data.settings)
                        // localStorage.setItem('welcome_video', settings.welcome_video);
                      }


                  })
                    .catch(err => {
                      // Vue.$toast.error(err, {
                      // position: 'top-right'
                      // });

                    });
          }

  },
  mounted: function () {
    let script = document.createElement("script");
      script.src =  "https://js.stripe.com/v2/";
      document.head.appendChild(script);

    // Public routes — skip all session/auth checks entirely
    const publicRoutes = ['/', '/view-inventory', '/about-us', '/reviews'];
    const currentPath = this.$route ? this.$route.path : window.location.pathname;
    const isPublicPage = publicRoutes.includes(currentPath) ||
                         currentPath.startsWith('/view-inventory-details');

    if (isPublicPage) {
      return; // No auth checks on public/inventory pages
    }

    let role = JSON.parse(localStorage.getItem('role'));
    if(localStorage.getItem('token')){
      this.checkSession()
      this.getClientSettings()
    }else{
      this.getSettings();
    }
  },
};
</script>
